import React from 'react';

import { Skeleton, SkeletonTheme, UiKit } from 'components';

export default function Loader({ isLoading = false, children = null }) {
  if (!isLoading) {
    return children;
  }

  const card = (
    <UiKit.Card>
      <UiKit.Card.Body>
        <UiKit.Flex justify="space-between">
          <UiKit.Flex gap={16}>
            <Skeleton height={16} width={32} className="my-1" />
            <UiKit.Flex direction="column" gap={8} className="my-1">
              <Skeleton height={16} width={200} />
              <Skeleton height={16} width={400} />
            </UiKit.Flex>
          </UiKit.Flex>
          <Skeleton height={24} width={56} />
        </UiKit.Flex>
      </UiKit.Card.Body>
    </UiKit.Card>
  );

  return (
    <SkeletonTheme className="m-0">
      <UiKit.Flex direction="column" gap={12}>
        {card}
        {card}
      </UiKit.Flex>
    </SkeletonTheme>
  );
}
